import { Link } from "react-router-dom";

import Newsletter from "@/components/common/Newsletter";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";
import VentaraMark from "@/components/common/VentaraMark";
import VentaraWordmark from "@/components/common/VentaraWordmark";

const groups = [
    {
        title: "Company",
        items: [
            { to: "/about", label: "About" },
            { to: "/careers", label: "Careers" },
            { to: "/contact", label: "Contact" },
            { to: "/insights", label: "Insights" },
            { to: "/faq", label: "FAQ" },
        ],
    },
    {
        title: "Work",
        items: [
            { to: "/solutions", label: "Solutions" },
            { to: "/products", label: "Products" },
            { to: "/industries", label: "Industries" },
            { to: "/studio", label: "Studio" },
        ],
    },
    {
        title: "Craft",
        items: [
            { to: "/technology", label: "Technology" },
            { to: "/research", label: "Research" },
            { to: "/vdl", label: "Design Language" },
        ],
    },
];

export default function Footer() {
    return (
        <footer className="border-t border-border mt-32" data-testid="site-footer">
            <div className="max-w-[1400px] mx-auto px-6 sm:px-10 pt-24 pb-16">
                <Newsletter source="footer" />
                <div className="grid lg:grid-cols-12 gap-16 mt-24">
                    <div className="lg:col-span-6">
                        <p className="label">Let's talk</p>
                        <h2 className="font-serif text-6xl sm:text-7xl lg:text-[10vw] leading-[0.9] tracking-tight mt-6">
                            Begin<br />quietly.
                        </h2>
                        <Link
                            to="/contact"
                            data-testid="footer-cta"
                            className="mt-10 inline-flex items-center gap-3 text-sm text-foreground border-b border-foreground/40 pb-1 hover:border-foreground transition-colors"
                        >
                            Start a conversation
                            <span aria-hidden>→</span>
                        </Link>
                    </div>

                    <div className="lg:col-span-6 grid grid-cols-3 gap-8">
                        {groups.map((g) => (
                            <div key={g.title}>
                                <p className="label mb-6">{g.title}</p>
                                <ul className="space-y-3">
                                    {g.items.map((i) => (
                                        <li key={i.to}>
                                            <Link
                                                to={i.to}
                                                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                                                data-testid={`footer-link-${i.label.toLowerCase().replace(/\s+/g, '-')}`}
                                            >
                                                {i.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-24 pt-8 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <VentaraMark size={20} />
                        <span className="text-xs text-muted-foreground inline-flex items-center gap-1"><VentaraWordmark height={9} className="relative top-px" /> · © {new Date().getFullYear()} · Make intelligence <span className="brand-gradient-text font-medium">feel natural</span>.</span>
                    </div>
                    <div className="flex items-center gap-6 text-xs text-muted-foreground">
                        <LanguageSwitcher />
                        <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-foreground transition-colors">Privacy</Link>
                        <Link to="/terms" data-testid="footer-link-terms" className="hover:text-foreground transition-colors">Terms</Link>
                        <Link to="/security" data-testid="footer-link-security" className="hover:text-foreground transition-colors">Security</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
